import(/* webpackMode: "eager" */ "/home/r11/choice-graphics/src/components/layout/app-footer/app-footer.tsx");
;
import(/* webpackMode: "eager" */ "/home/r11/choice-graphics/src/components/layout/app-header/app-header.tsx");
;
import(/* webpackMode: "eager" */ "/home/r11/choice-graphics/src/components/layout/app-sidebar/app-sidebar.tsx");
;
import(/* webpackMode: "eager" */ "/home/r11/choice-graphics/src/components/layout/global-header/global-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PubMain"] */ "/home/r11/choice-graphics/src/components/layout/pub-main.tsx");
